module.exports = __webpack_public_path__ + "6f2c9085f976f9797240d323f579a3db.svg";